/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'lender',

  can: {
    // page access guarded by auth-routes.  these rules set up the perimeter for page level access rights

    view () {
      return true;
    },

    // this is really only an OCI administrative function (super).  a developer (at this point) will not be able to change
    // developer, but in the future this could be developed to support a multi-organization developer firm.
    viewAllLenders() {
      return this.isSuper()
    },

    // for future use we can check to see if the active user is allowed into specific projects for their firm, or all.
    // for now we are allowing a developer firm representative to see all projects in their firm
    viewAllProjects() {
      return this.isSuper() || this.isLenderGroup()
    },

    // only let manager level users into the lending criteria section
    viewLendingCriteria() {
      return this.isSuper() || this.isLenderManager() ||  this.isLenderAdmin()
    },

    // follow same rules as per viewLendingCriteria
    editLendingCriteria() {
      return this.isAllowed('viewLendingCriteria')
    },
    // Lender Dashboard Menu General
    viewLenderDashboard(){
      return this.isSuper() || this.isLenderGroup()
    },
  },

  isSuper() {
    return this.child.isSuper
  },

  isLender() {
    return this.child.isLender;
  },

  isLenderAdmin() {
    return this.child.isLenderAdmin;
  },
  isLenderManager() {
    return this.child.isLenderManager;
  },
  isOciGroup() {
    return this.child.isOciGroup;
  },
  isLenderGroup() {
    return this.child.isLenderGroup;
  },
  isSuperGroup() {
    return this.child.isSuperGroup;
  },
  isDeveloperGroup() {
    return this.child.isDeveloperGroup;
  },
  isPartnerGroup() {
    return this.child.isPartnerGroup;
  },
});
